import { useNavigate, useParams } from "react-router-dom";
import { Text } from "@chakra-ui/react";
import CompletionBoard from "../components/CompletionBoard";

const Board = () => {
  const { courseId, moduleId, mode: status } = useParams();
  const navigate = useNavigate();

  if (!status || !courseId || !moduleId) {
    // todo add the error page
    return <>The Page not found</>;
  }

  if (status === "learn") {
    return (
      <CompletionBoard
        // value={"32"}
        color="#FFC107"
        title={
          <>
            <Text fontSize="2xl" fontWeight="bold">
              Lesson
            </Text>
            <Text fontSize="2xl" fontWeight="bold">
              Completed!
            </Text>
          </>
        }
        onClick={() => navigate(`/dashboard/course/${courseId}`)}
      />
    );
  }

  if (status === "review") {
    return (
      <CompletionBoard
        color="#FFC107"
        description={"Great job reinforcing your knowledge!"}
        title={
          <>
            <Text fontSize="3xl" fontWeight="bold">
              Lesson
            </Text>
            <Text fontSize="3xl" fontWeight="bold">
              Reviewed!
            </Text>
          </>
        }
        onClick={() => navigate(`/dashboard/course/${courseId}`)}
      />
    );
  }
  if (status === "practice") {
    return (
      <CompletionBoard
        // value={"32"}
        color="#FFC107"
        title={
          <>
            <Text fontSize="2xl" fontWeight="bold">
              Pratice
            </Text>
            <Text fontSize="2xl" fontWeight="bold">
              Completed!
            </Text>
          </>
        }
        onClick={() => navigate(`/dashboard/course/${courseId}`)}
      />
    );
  }
};

export default Board;
